import { render, staticRenderFns } from "./ImportProductPOShareModal.vue?vue&type=template&id=f2b8fc92"
import script from "./ImportProductPOShareModal.vue?vue&type=script&lang=js"
export * from "./ImportProductPOShareModal.vue?vue&type=script&lang=js"
import style0 from "./ImportProductPOShareModal.vue?vue&type=style&index=0&id=f2b8fc92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports